// /jlpt/calculator: shows the fields of the way the reader chose, and only the
// score fields the chosen level scores. ⛔ Native DOM, no React, no figures.
import { showsScoreField, showsWay } from 'utils/examCalculatorForm'

function setup() {
  const form = document.querySelector('[data-jlpt-form]')
  if (!form) return

  const target = form.querySelector('[data-jlpt-target]')

  const update = () => {
    const chosen = form.querySelector('[data-jlpt-way-choice]:checked')?.value || 'self'
    form.querySelectorAll('[data-jlpt-way]').forEach((group) => {
      group.hidden = !showsWay(group.dataset.jlptWay, chosen)
    })
    form.querySelectorAll('[data-jlpt-levels]').forEach((field) => {
      const shown = showsScoreField(field.dataset.jlptLevels, target?.value)
      field.hidden = !shown
      // A hidden field is not sent, so a stale score cannot reach the server.
      field.querySelectorAll('input').forEach((input) => { input.disabled = !shown })
    })
  }

  form.addEventListener('change', update)
  update()
}

document.addEventListener('DOMContentLoaded', setup)
